export class ContractTemplate {
    id = null;

    description = '';

    allowLinkedWorkOrders = false;

    allowSelfDispatch = false;

    enableNonFlaggingTimesheets = false;
    contractUnionWorkTypeId = 1;

    active = true;

    workOrderTypeId = null;

    workOrderTypeDescription = '';

    contractScheduleTypeId = 1;

    contractScheduleTypeDescription = '';

    isProjectContract = false;

    chargeTypes = [];

    compliances = [];

    createdById = '';

    createdByName = '';

    createdOn = null;

    modifiedById = '';

    modifiedByName = '';

    modifiedOn = null;
}
